"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelSubmitWebBlConsigneeCertification = cancelSubmitWebBlConsigneeCertification;
exports.confirmEmail = confirmEmail;
exports.deletehWebBlConsigneeCertification = deletehWebBlConsigneeCertification;
exports.getExport = getExport;
exports.getQueryListCrdit = getQueryListCrdit;
exports.queryListCodeCREDIT_CUSTOMER = queryListCodeCREDIT_CUSTOMER;
exports.queryListCodeNameCREDIT_AGENT = queryListCodeNameCREDIT_AGENT;
exports.saveWebBlConsigneeCertification = saveWebBlConsigneeCertification;
exports.submithWebBlConsigneeCertification = submithWebBlConsigneeCertification;
exports.updateDoLessByBkId = updateDoLessByBkId;
var _request = _interopRequireDefault(require("@/utils/request"));
function queryListCodeNameCREDIT_AGENT() {
  return (0, _request.default)({
    url: '/ebusiness/credit/getAgent',
    // url: '/webBlConsigneeCertification/add',
    method: 'get'
  });
}
function queryListCodeCREDIT_CUSTOMER() {
  return (0, _request.default)({
    url: '/ebusiness/credit/getCustomerCode',
    // url: '/webBlConsigneeCertification/add',
    method: 'get'
  });
}
function getQueryListCrdit(data) {
  return (0, _request.default)({
    url: '/ebusiness/credit/queryList',
    // url: '/webBlConsigneeCertification/search',
    method: 'get',
    params: data
  });
}
function updateDoLessByBkId(data) {
  return (0, _request.default)({
    url: '/ebusiness/credit/updateDoLessByBkId',
    method: 'post',
    data: data
  });
}
function confirmEmail(data) {
  return (0, _request.default)({
    url: '/ebusiness/credit/confirmEmail',
    method: 'post',
    data: data
  });
}
function getExport(data) {
  return (0, _request.default)({
    responseType: 'blob',
    url: '/ebusiness/credit/creditExportExcel',
    // url: '/webBlConsigneeCertification/add',
    method: 'get',
    params: data
  });
}
function deletehWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/deleteBatch',
    // url: '/webBlConsigneeCertification/deleteBatch',
    method: 'post',
    data: data
  });
}
function saveWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/edit',
    // url: '/webBlConsigneeCertification/edit',
    method: 'post',
    data: data
  });
}
function submithWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/submit',
    // url: '/webBlConsigneeCertification/submit',
    method: 'post',
    data: data
  });
}
function cancelSubmitWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/cancelSubmit',
    // url: '/webBlConsigneeCertification/cancelSubmit',
    method: 'post',
    data: data
  });
}